import { Container } from "react-bootstrap";
import { motion } from "framer-motion";

export default function Footer() {
  return (
    <motion.footer
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1 }}
      className="bg-light shadow-sm py-4"
    >
      <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ type: "spring", stiffness: 120 }}
          className="fw-bold text-primary mb-2 mb-md-0"
        >
          Momentary ✨
        </motion.div>
        <motion.div
          whileHover={{ scale: 1.05, color: "#10b981" }}
          transition={{ type: "spring", stiffness: 150 }}
          className="text-center text-md-end mt-2 mt-md-0"
        >
          © 2025 Momentary. All moments reserved. 🌿
        </motion.div>
      </Container>
    </motion.footer>
  );
}
